<template>
    <v-layout row wrap class="stores-list" v-if="stores.length > 0">
        <v-flex xs12 md6 lg4
                v-for="store in stores_ordered"
                :key="store.id"
                @click="clickStore(store)">
            <v-card hover
                    :class="[store.id === selectedStoreId ? 'store-list-card selected' : 'store-list-card']">
                <v-img class="storeslist-img" v-if="store.image && baseUrl && displayImage"
                       v-bind:src="baseUrl + store.image"
                       height="150"></v-img>

                <v-card-actions
                        :class="[store.id === selectedStoreId ? 'pa-2 secondary--text text-truncate font-weight-bold' : 'pa-2 primary--text text-truncate font-weight-bold']">
                    <span v-if="store.distance"
                          :class="[store.id === selectedStoreId ? 'secondary--text' : 'grey--text']"
                    >{{ store.distance | formatDistance }} Km</span>
                    <v-spacer></v-spacer>
                    {{ store.name }}
                    <v-spacer></v-spacer>
                    <v-btn v-if="displayGoToDetail" icon class="mr-0">
                        <v-icon color="primary">fal fa-angle-double-right</v-icon>
                    </v-btn>
                    <v-btn v-else icon class="mr-0">
                        <v-icon :class="[store.id === selectedStoreId ? 'secondary--text font-weight-bold' : 'primary--text']">
                            fal fa-map-pin
                        </v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
    <v-layout row wrap class="stores-list" v-else>
        <v-flex xs12>
            <v-layout align-center justify-center column>
                <v-spacer class="my-4"></v-spacer>
                <h2 class="title text-xs-center">{{ $vuetify.t('$vuetify.stores_not_available') }}</h2>
            </v-layout>
        </v-flex>
    </v-layout>

</template>

<script>
import {getDistanceFromLatLonInKm, getErrorMessage} from '@/_helpers'
import {storesService} from '@/_services'
import {mapGetters} from "vuex";

export default {
    name: "StoresListComp",
    data() {
        return {
            stores: [],
            location: null,
        }
    },
    //Parent (StoresList.vue and OrderStepDelivery.vue) to Child (UserForm.vue) Communication
    //The "props" are the elements which enable moving data from a parent component to a child component
    //"Props" is short for “properties” and is referring to properties set from the parent component
    //Note that props are strictly for one way communication from the parent to the child,
    // and you do not want to try and change the value of a prop directly in the child component.
    // To change a parent's property, a computed property from the parent should be used.
    props: {
        displayImage: Boolean,
        displayGoToDetail: Boolean,
        select: Boolean,
        referenceLocation: Object,
        selectedStoreId: Number
    },
    methods: {
        /**
         * The method assigned to the button which is displayed once the Shopping Cart is empty. This button
         * redirects the user to the Catalog
         **/
        goToDetail: function (pk) {
            this.$router.push({name: 'stores-detail', params: {id: pk}})
        },
        /**
         * The Store clicked (clickStore method) may be communicated back up to the parent
         * (OrderStepDelivery.vue), so the parent knows which Store the user choose to collect the Order.
         * This "backwards" communication is implemented by the "emit": the child component emits an event on itself
         * by calling the built-in $emit method, passing the name of the event "selected".
         * This "selected" is bind to the prop @selected="handleStoreSelected"
         * @param store
         */
        handleStoreSelected(store) {
            this.$emit('selected', store);
        },
        /**
         * Depending on which parent's context the component is being used, the action of clicking on a Store
         * can have two different behaviours: (1) going to the detail of the store (parent StoresList.vue);
         * (2) saving the store where the Order should be collected (OrderStepDelivery.vue)
         * @param store
         */
        clickStore(store) {
            if (this.displayGoToDetail) {
                this.goToDetail(store.id)
            } else {
                this.handleStoreSelected(store)
            }
        },
    },
    computed: {
        stores_ordered() {
            let stores_list = this.stores;

            var i;
            for (i = 0; i < stores_list.length; i++) {
                if (stores_list[i].latitude && stores_list[i].longitude) {
                    stores_list[i].distance = getDistanceFromLatLonInKm(stores_list[i].latitude, stores_list[i].longitude, this.referenceLocation['latitude'], this.referenceLocation['longitude'])
                } else {
                    stores_list[i].distance = undefined;
                }
            }
            //Tentei utilizar return _.orderBy(this.users, 'name') mas não funcionou
            stores_list.sort(function (a, b) {
                if (a.distance === undefined && b.distance === undefined)
                    return 0;
                else if (a.distance === undefined)
                    return 1;
                else if (b.distance === undefined)
                    return -1;
                return a.distance - b.distance;
            });

            return stores_list;
        },
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    filters: {
        formatDistance(value) {
            return (value / 1).toFixed(1);
        }
    },
    mounted() {
        if (!this.stores || this.stores.length === 0) {
            storesService.getAll().then(result => {
                    this.stores = result.results;
                    this.$store.dispatch("loader/setLoading", false);
                },
                error => {
                    getErrorMessage(error, 'Getting the Stores', this);
                }
            );
        }
    }
}
</script>

<style scoped>

</style>